import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export type LocalUser = {
  id?: number
  name?: string
  token?: string
}

export const shopId = atom(0)
export const userInfo = atomWithStorage<LocalUser>('userInfo', {})
